var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3DotsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8001 6.39526C13.6838 6.39526 14.4001 7.11161 14.4001 7.99526V8.00486C14.4001 8.88852 13.6838 9.60486 12.8001 9.60486C11.9164 9.60486 11.2001 8.88852 11.2001 8.00486V7.99526C11.2001 7.11161 11.9164 6.39526 12.8001 6.39526Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0001 6.39526C8.88375 6.39526 9.6001 7.11161 9.6001 7.99526V8.00486C9.6001 8.88852 8.88375 9.60486 8.0001 9.60486C7.11644 9.60486 6.4001 8.88852 6.4001 8.00486V7.99526C6.4001 7.11161 7.11644 6.39526 8.0001 6.39526Z",
    fill: "#667085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2001 6.39526C4.08375 6.39526 4.8001 7.11161 4.8001 7.99526V8.00486C4.8001 8.88852 4.08375 9.60486 3.2001 9.60486C2.31644 9.60486 1.6001 8.88852 1.6001 8.00486L1.6001 7.99526C1.6001 7.11161 2.31644 6.39526 3.2001 6.39526Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DotsIcon);
export default __webpack_public_path__ + "static/media/3Dots-icon.63bc59c6f81856452d2e330f61c727d1.svg";
export { ForwardRef as ReactComponent };